import React, { useEffect, useState } from "react";
import {
    TextField,
} from "@mui/material";

export default function PullModificationNumericTextField(props) {

    const { disabled, setPlateNumericValue, plateNumericValue } = props

    const [value, setValue] = useState(plateNumericValue ?? '')

    useEffect(() => {
        setPlateNumericValue(value)
    }, [value])

    const validateNumber = (value) => {
        const numberRegex = /^\d+$/;
        return numberRegex.test(value)
    }

    return (
        <TextField
            variant="standard"
            value={value}
            disabled={disabled}
            onKeyDown={(e) => {
                e.stopPropagation()
                if (e.key === 'Escape') {
                    e.target.blur()
                }
                if (e.key === 'Enter') {
                    e.target.blur()
                }
            }}
            onChange={(event) => {
                if(validateNumber(event.target.value) === false) return;
                setValue(event.target.value);
            }}
            fullWidth
            sx={{
                input: {
                    color: 'white',
                    fontSize: '13px',
                    padding: '4px 8px'
                },
                '& .MuiInput-underline:before': {
                    borderBottom: disabled ? 'none' : '1px solid rgba(84, 162, 119, 0.4)'
                },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottom: disabled ? 'none' : '1px solid rgba(76, 146, 107, 0.8)'
                },
                '& .MuiInput-underline:after': {
                    borderBottom: disabled ? 'none' : '1px solid rgba(84, 162, 119, 1)'
                },
            }}
        />
    )
}